<template>
	<div :style="{direction: $vs.rtl ? 'rtl' : 'ltr'}">
		<feather-icon
			icon="EditIcon"
			svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
			:title="$t('Edit')"
			@click="editRecord"
		/>
		<feather-icon
			v-if="optimizerManagerDeletePermission"
			icon="Trash2Icon"
			svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
			:title="$t('Crud.Delete')"
			@click="confirmDeleteRecord"
		/>
	</div>
</template>

<script>
export default {
	name: "CellRendererActions",
	computed: {
		optimizerManagerDeletePermission() {
			return this.$store.getters.checkPermission("OPTIMIZER_MANAGER_D");
		},
	},
	methods: {
		editRecord() {
			this.$router.push("/apps/optimizer-manager/optimizer-manager-edit/" + this.params.data.id).catch(() => {});
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text:
					this.$t("OptimizerManager.DeleteOptimizerManager.Text1") +
					` "${this.params.data.id}"? ` +
					this.$t("OptimizerManager.DeleteOptimizerManager.Text2"),
				accept: this.deleteRecord,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$store
				.dispatch("optimizerManager/deleteById", this.params.data.id)
				.then((res) => {
					this.showDeleteSuccess();
				})
				.catch((err) => {
					console.error(err);
				});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("OptimizerManager.CellRenderer.DeleteSuccess.Title"),
				text: this.$t("OptimizerManager.CellRenderer.DeleteSuccess.Text"),
			});
		},
	},
};
</script>
